module.exports = __webpack_public_path__ + "img/sunflower.4fa1c328.jpg";